// Business constants (from Cahier des Charges §4)
export const CONSTANTS = {
  TAUX_ENDETTEMENT_MAX: 0.35,        // 35% — HCSF
  TAUX_ENDETTEMENT_ALERTE: 0.33,     // 33% — seuil rachat de crédits
  RESTE_A_VIVRE_MIN: 800,            // €
  DUREE_EMPRUNT_MOIS: 240,           // 20 ans
  POIDS_CHARGES_ALERTE: 0.50,        // 50%
  POIDS_CHARGES_OPPORTUNITE: 0.20,   // 20%
  POIDS_VARIABLES_ALERTE: 0.40,      // 40%
  POIDS_VARIABLES_OPPORTUNITE: 0.35, // 35%
  TAUX_OPTIM_VARIABLES_DEFAUT: 0.10, // 10%
  TAUX_OPTIM_FIXES_DEFAUT: 0.05,     // 5%
};

export const REVENU_FIELDS = [
  "salaire1", "salaire2", "bic", "bnc", "dividendes",
  "allocationsCaf", "pension", "pensionAlimentaire", "autresRevenus",
];

export const CHARGES_FIXES_FIELDS = [
  "loyer", "chargesCopro", "assuranceHabitation",
  "electricite", "gaz", "eau",
  "telecomInternet",
  "mutuelle", "autresAssurances",
  "assuranceAuto", "carburant", "entretienVehicule",
];

export const CREDITS_FIELDS = [
  "creditImmo", "creditAuto", "creditConso", "creditRenouvelable", "autresCredits",
];

export const DEPENSES_VARIABLES_FIELDS = [
  "alimentation", "hygienePharmacie", "gardeEnfants",
  "restaurantsSorties", "abonnements", "autresVariables",
];

export const CLIENT_FIELDS = [
  "nom", "prenom", "telephone", "email", "adresse",
  "situationFamiliale", "nombreEnfants", "statutLogement",
  "objectifPatrimonial", "horizonPlacement",
];

export const SITUATION_FAMILIALE_OPTIONS = ["celibataire", "marie", "pacse", "divorce", "veuf"];
export const STATUT_LOGEMENT_OPTIONS = ["locataire", "proprietaire", "heberge"];
export const HORIZON_OPTIONS = ["court", "moyen", "long"];
